module.exports = __webpack_public_path__ + "static/media/01.5b2e6f36.jpg";